import styled, {css} from 'styled-components'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'

export const StyledNotificationBadge = styled(Flexbox)(
    ({theme: {palette, typography, spacing}}) => css`
        min-width: 16px;
        height: 16px;
        border-radius: 16px;
        background-color: ${palette.danger['500']};
        color: ${palette.neutral.white};
        ${typography.textXs};
        font-size: 10px;
        font-weight: 600;
        padding: 0 ${spacing * 0.5}px;
        position: absolute;
        top: 6px;
        right: 8px;
        transform: translate(50%, -50%);
        box-sizing: border-box;
        border: 1px solid white;
    `
)
